
<div class= "border-b font-Sora header border-[#edf2f9] dark:border-none bg-#FBFBFF dark:bg-[#323540] min-h-[72px] fixed top-0 w-full z-[1000] flex">
  <div class="border-r border-[#edf2f9] dark:border-transparent logo logo-dark transition duration-200 ease-in-out items-center h-[71px]">
    <a class="block text-center" routerLink="/dashboard/qualidade">
      <img id="logo-img" class="ps-[30px] pr-[15px]" src="assets/images/logo/logo-Lacpoint.png" alt="Logo">
      <img id="logo-fold-img" class="p-[24px] logo-fold pr-[15px]" src="assets/images/logo/lacpoint-logo-fold.png" alt="Logo">
    </a>
  </div>
  <div class="flex flex-1 nav-wrap md:ps-[20px] md:pe-[30px] ps-[10px] pe-[15px] bg-white dark:bg-[#1b1d2a]">
    <ul class="flex items-center mb-0 list-none nav-left ps-0 gap-x-[14px] gap-y-[9px]">
      <li class="desktop-toggle">
        <a class="flex items-center justify-center w-[40px] h-[40px] rounded-full bg-transparent hover:bg-primary/10 hover:text-primary group transition duration-200 ease-in-out text-[#525768] dark:text-white/60 dark:hover:bg-white/10" (click)="toggleFold()">
          <svg-icon [ngClass]="{
            'is-folded': isFolded,
            'is-expand' : isExpand
          }" class="[&>svg]:w-[20px] text-current [&.is-folded>svg]:hidden" src="assets/images/svg/align-center-alt.svg" />
          <svg-icon [ngClass]="{
            'is-folded': isFolded,
            'is-expand' : isExpand
          }" class="[&>svg]:w-[20px] text-current [&>svg]:hidden [&.is-folded>svg]:block" src="assets/images/svg/align-left.svg" />
        </a>
      </li>
      <li class="mobile-toggle">
        <a class="flex items-center justify-center w-[40px] h-[40px] rounded-full bg-transparent hover:bg-primary/10 hover:text-primary group transition duration-200 ease-in-out text-[#525768] dark:text-white/60 dark:hover:bg-white/10" (click)="toggleExpand()">
          <svg-icon [ngClass]="{
            'is-folded': isFolded,
            'is-expand' : isExpand
          }" class="[&>svg]:w-[20px] text-current [&.is-expand>svg]:hidden" src="assets/images/svg/align-center-alt.svg" />
          <svg-icon [ngClass]="{
            'is-folded': isFolded,
            'is-expand' : isExpand
          }" class="[&>svg]:w-[20px] text-current [&>svg]:hidden [&.is-expand>svg]:block" src="assets/images/svg/align-left.svg" />
        </a>
      </li>
    </ul>
    <!-- Top Menu -->
    <app-menu></app-menu>
    <!-- desktop -->
    <div class="items-center hidden ms-auto xl:flex">
      <ng-container *ngTemplateOutlet="myTemplate"></ng-container>
    </div>
    <ng-template #myTemplate>
      <ul class="flex items-center justify-end flex-auto mb-0 list-none ps-0 nav-right sm:gap-x-[25px] max-sm:gap-x-[15px] gap-y-[15px]">
        <li>
          <span class="flex items-center cursor-pointer text-light whitespace-nowrap" nz-dropdown [nzDropdownMenu]="profile">
            <nz-avatar [nzIcon]="'user'" [nzSrc]="avatarUrl"></nz-avatar>
            <span class="me-1.5 ms-2.5 text-body dark:text-white/60 text-sm font-medium max-md:hidden">{{nomeUsuario}}</span>
            <span class="[&>svg]:w-[10px] [&>svg]:h-[10px] [&>svg]:max-md:ms-[5px]" nz-icon nzType="down" nzTheme="outline"></span>
          </span>
          <nz-dropdown-menu #profile="nzDropdownMenu">
            <div class="min-w-[310px] max-sm:min-w-full pt-4 px-[15px] py-[12px] bg-white dark:bg-[#1b1e2b] shadow-[0_2px_8px_rgba(0,0,0,.15)] dark:shadow-[0_5px_30px_rgba(1,4,19,.60)] rounded-4">
              <figure
                class="flex items-center text-sm rounded-[8px] bg-section dark:bg-white/10 py-[20px] px-[25px] mb-[12px]">
                <nz-avatar [nzIcon]="'user'" [nzSrc]="avatarUrl" class="me-4"></nz-avatar>
                <figcaption>
                  <h1 class="text-dark dark:text-white/[.87] mb-0.5 text-sm">{{nomeUsuario}}</h1>
                  <p class="mb-0 text-xs text-body dark:text-white/60">{{tipoUsuario}}</p>
                </figcaption>
              </figure>
              <ul nz-menu class="mb-0 bg-transparent shadow-none">
                <li class="p-0 dark:hover:text-white hover:bg-primary/10 dark:hover:bg-white/10 rounded-4" nz-menu-item *ngFor="let authorMenu of appAuthorMenu">
                  <button (click)="navegar(authorMenu.url)"
                    class="inline-flex items-center text-light dark:text-white/60 hover:text-primary hover:ps-6 w-full px-2.5 py-3 text-sm transition-all ease-in-out delay-150">
                      <svg-icon class="h-fit me-4 [&>svg]:w-[18px] [&>svg]:h-[18px]" src="assets/images/svg/feather/{{authorMenu.icon}}.svg" alt="{{authorMenu.icon}}"></svg-icon>
                      {{authorMenu.label}}</button>
                  </li>
              </ul>
              <a
                class="flex items-center justify-center text-sm font-medium bg-[#f4f5f7] dark:bg-[#32333f] h-[50px] text-light hover:text-primary dark:hover:text-white/60 dark:text-white/[.87] mx-[-15px] mb-[-15px] rounded-b-6"
                href="#" (click)="signOut()">
                <i class="sair"></i> Sair </a>
            </div>
          </nz-dropdown-menu>
        </li>
      </ul>
    </ng-template>
    <!-- desktop -->
    <!-- Mobile -->
    <a class="items-center hidden max-xl:flex text-light text-[18px] dark:text-white/[.87] ms-auto" nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu">
      <span nz-icon nzType="more" nzTheme="outline"></span>
    </a>
    <nz-dropdown-menu #menu="nzDropdownMenu">
      <div class="bg-white dark:bg-[#1b1c29] px-[20px] py-[6px] rounded-6 hidden max-xl:block">
        <ng-container *ngTemplateOutlet="myTemplate"></ng-container>
      </div>
    </nz-dropdown-menu>
    <!-- Mobile -->
  </div>
</div>
